import { useRef, useState, useEffect, useReducer } from 'react';
import HeroPages from "../components/HeroPages";
import { collection, getDocs, query, where } from "firebase/firestore";
import {db} from '../firebase';
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { Table, Space, Button, Input } from 'antd';
import { IconPhoneCall } from "@tabler/icons-react";
import whatsappbtn from "../images/whatsapp/WhatsAppButtonGreenLarge.svg";
import { SearchOutlined } from '@ant-design/icons';
import DatePicker from "react-datepicker";
import { format } from "date-fns";
//import Highlighter from 'react-highlight-words';

const { Column } = Table;

function Bookings(props) {
    // const [data, _setData] = useState(() => [...defaultData]);
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    auth.provider = provider;

    const rerender = useReducer(() => ({}), {})[1]
    const [data, _setData] = useState([]);
    const [sorting, setSorting] = useState({ columnId: "pickTime", ascending: false });

    ///////////////////////////////
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const [bookingDate, setBookingDate] = useState(new Date());
  
    const handleSearch = (
      selectedKeys,
      confirm,
      dataIndex,
    ) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    };
  
    const handleReset = (clearFilters) => {
      clearFilters();
      setSearchText('');
    };
  
    const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters)}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                confirm({ closeDropdown: false });
                setSearchText((selectedKeys)[0]);
                setSearchedColumn(dataIndex);
              }}
            >
              Filter
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
              }}
            >
              close
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          .toString()
          .toLowerCase()
          .includes((value).toLowerCase()),
      filterDropdownProps: {
        onOpenChange(open) {
          if (open) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
      },
      render: (text) =>
        searchedColumn === dataIndex ? (
        //   <Highlighter
        //     highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        //     searchWords={[searchText]}
        //     autoEscape
        //     textToHighlight={text ? text.toString() : ''}
        //   />
         text
        ) : (
          text
        ),
    });
    ///////////////////////////////

    const fetchBookings = async () => {
        const month = format(bookingDate, "MMM");
        const year = format(bookingDate, "yyyy");
        //const end = month.replace(/.$/, c => String.fromCharCode(c.charCodeAt(0) + 1));

        // Reference a Firestore collection
        const collectionRef = collection(db, "bookings");

        // Create a query with a where clause
        //const q = query(collectionRef);
        const q = query(collectionRef, where('booking.monthIndex', '==', month), where('booking.yearIndex', '==', year))

        const querySnapshot = await getDocs(q)           
        const newData = querySnapshot.docs.map((doc) => ({...doc.data().booking, id:doc.id }));  
        _setData(newData);
        console.log(newData);
    }

    const handleBookingDate = (bDate) => {
      setBookingDate(bDate);
    };

    useEffect(()=>{
        if(auth.currentUser && ((auth.currentUser.email === "vrycue@gmail.com") || (auth.currentUser.email === "delunaphoebe06@gmail.com")))
        {
          fetchBookings();
        }
        else
        {
            window.location.replace('./');
        }
    }, [auth])

    const COLUMN_HEADER_BOOKINGS = [
        {
            title: 'Booking Ref',
            dataIndex: 'id',
            key: 'id',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.id > b.id,
            sortDirections: ['ascend','descend'],
        },
        {
            title: 'Order ID',
            dataIndex: 'orderID',
            key: 'orderID',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.orderID > b.orderID,
            sortDirections: ['ascend','descend'],
            ...getColumnSearchProps('orderID'),
        },
        {
            title: 'Booking Type',
            dataIndex: 'bookingType',
            key: 'bookingType',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.bookingType > b.bookingType,
            sortDirections: ['ascend','descend'],
        },        
        {
            title: 'Vehicle',
            dataIndex: 'carType',
            key: 'carType',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.carType > b.carType,
            sortDirections: ['ascend','descend'],
        },
        {
            title: 'Plate Number',
            dataIndex: 'carPlate',
            key: 'carPlate',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.carPlate > b.carPlate,
            sortDirections: ['ascend','descend'],
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.lastName > b.lastName,
            sortDirections: ['ascend','descend'],
        },
        {
            title: 'First Name',
            dataIndex: 'name',
            key: 'name',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.name > b.name,
            sortDirections: ['ascend','descend'],
        },
        {
            title: 'Phone No.',
            dataIndex: 'phone',
            key: 'phone',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.name > b.name,
            sortDirections: ['ascend','descend'],
        },
        {
            title: 'Pick-Up',
            dataIndex: 'pickUp',
            key: 'pickUp',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.pickUp > b.pickUp,
            sortDirections: ['ascend','descend'],
        },   
        {
            title: 'Drop-Off',
            dataIndex: 'dropOff',
            key: 'dropOff',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.dropOff > b.dropOff,
            sortDirections: ['ascend','descend'],
        }, 
        {
            title: 'Start Date',
            dataIndex: 'pickTime',
            key: 'pickTime',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.pickTime > b.pickTime,
            sortDirections: ['ascend','descend'],
        }, 
        {
            title: 'Return Date',
            dataIndex: 'dropTime',
            key: 'dropTime',
            showSorterTooltip: {
                target: 'full-header',
            },
            sorter: (a, b) => a.dropTime > b.dropTime,
            sortDirections: ['ascend','descend'],
        }, 
        {
            title: 'Action',
            key: 'action',
            showSorterTooltip: {
                target: 'full-header',
            },
            render: (record) => (
                <Space size="middle">
                <ul>
                <li>
                    <a href={"tel:"+record.phone}>
                    <IconPhoneCall /> &nbsp; (63) -915-355-9915
                    </a>
                </li>
                <li>
                    <a aria-label="Chat on WhatsApp" href={"https://wa.me/"+record.phone.trim("+")}> 
                    <img alt="Chat on WhatsApp" src={whatsappbtn}/>
                    </a>              
                </li>
                </ul>
                </Space>
            )
        }, 
      ]
     
    return (        
        <>
        {(auth.currentUser && ((auth.currentUser.email === "vrycue@gmail.com") || (auth.currentUser.email === "delunaphoebe06@gmail.com")))?
        <section id="home" className="hero-section">
        <HeroPages name="Bookings" />
        <div className="container">   
            <DatePicker 
              id="droptime"
              selected={bookingDate}
              showMonthYearPicker
              onChange={handleBookingDate}
              dateFormat="MMMM yyyy"
              onFocus={e => e.target.blur()}
            ></DatePicker>

            <button className="search_btn" onClick={fetchBookings}>Show Month</button>

            <Table 
                columns={COLUMN_HEADER_BOOKINGS} 
                dataSource={data}
                showSorterTooltip={{
                target: 'sorter-icon',
                }}>           
                <Column
                title="Action"
                key="action"
                render={(record) => (
                    <Space size="middle">
                    <ul>
                    <a> {record.phone}</a>
                    <li>
                        <a href={"tel:"+record.phone}>
                        <IconPhoneCall /> &nbsp; (63) -915-355-9915
                        </a>
                    </li>
                    <li>
                        <a aria-label="Chat on WhatsApp" href={"https://wa.me/"+record.phone.trim("+")}> 
                        <img alt="Chat on WhatsApp" src={whatsappbtn}/>
                        </a>              
                    </li>
                    </ul>
                    </Space>
                )}
                />
            </Table>
        </div>
        </section>
        :
        <HeroPages name="Restricted Access"/>
        }
        </>
    )
}

export default Bookings;